module.exports = __webpack_public_path__ + "img/body-blood-detox.e9fec0e.svg";